import {
    PACKAGES_OVERVIEW_REQUEST,
    PACKAGES_OVERVIEW_RESULT,
} from 'Redux/actionTypes';

export const packagesOverviewRequest = (data) => ({
    type: PACKAGES_OVERVIEW_REQUEST,
    payload: data
})

export const packagesOverviewResult = (data) => ({
    type: PACKAGES_OVERVIEW_RESULT,
    payload: data
})